<template>
  <transition name="fade">
    <div class="round-start-container">
      <div
        v-show="roundIndex === 0"
        class="round-animation-wrapper"
      >
        <RoundOneStartAnimation />
      </div>
      <div
        v-show="roundIndex === 1"
        class="round-animation-wrapper"
      >
        <RoundTwoStartAnimation />
      </div>
      <div
        v-show="roundIndex === 2"
        class="round-animation-wrapper"
      >
        <RoundThreeStartAnimation />
      </div>
      <div class="round-start-item">
        {{ roundIndex === 0 ? "Let's start easy!" :
           roundIndex === 1 ? "Time to raise the stakes!" :
           roundIndex === 2 ? "It's not over yet!" : '' }}
      </div>
      <div class="round-start-item">
        {{ roundIndex === 0 ? "You'll gain 10 points for each vote you win." :
           roundIndex === 1 ? "Players gain 20 points per vote." :
           roundIndex === 2 ? "Players gain 50 points per vote!" : '' }}
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import RoundOneStartAnimation from '@/components/gameComponents/RoundOneStartAnimation';
import RoundTwoStartAnimation from '@/components/gameComponents/RoundTwoStartAnimation';
import RoundThreeStartAnimation from '@/components/gameComponents/RoundThreeStartAnimation';

export default Vue.extend({
  name: 'RoundStartView',
  components: {
    RoundOneStartAnimation,
    RoundTwoStartAnimation,
    RoundThreeStartAnimation
  },
  props: {
    roundIndex: Number
  }
})
</script>

<style scoped lang="scss">
.round-start-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  color: $brand-gold;
  background-color: $eigengrau;
}

.round-start-item {
  flex: 0;
  font-size: 1.5em;
  padding: 0.5em;
}

.round-animation-wrapper {
  flex: 0;
  font-size: 1em;
  padding-bottom: 4em;
}
</style>
